export const isTouchDevice = () => 'ontouchstart' in document.documentElement;

export const isAppleMobileDevice = () => /(iPhone|iPod|iPad)/i.test(navigator.platform);

export const isAppleDevice = () => {
  const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

  return isMacLike || isAppleMobileDevice();
};
